import {
  AreaChartOutlined,
  CalculatorOutlined,
  CarryOutOutlined,
  DashboardOutlined,
  ExperimentOutlined,
  ExportOutlined,
  MailOutlined,
  MoneyCollectOutlined,
  SettingOutlined,
  ToolOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from '@ant-design/icons';

import roles from './roles';

import { MenuItem } from 'common/components/Sidebar';
import { ROUTE_PATHS } from 'common/utils/constant';

const menuSidebar: MenuItem[] = [
  {
    key: 'dashboard',
    title: 'sidebar.dashboard',
    path: '/',
    icon: <DashboardOutlined />,
  },
  {
    key: 'employee',
    title: 'sidebar.employee',
    icon: <UsergroupAddOutlined />,
    items: [
      {
        key: 'employee_management',
        title: 'sidebar.employee',
        path: ROUTE_PATHS.EMPLOYEE_MANAGEMENT,
        role: roles.EMPLOYEE_INDEX,
        childrens: [ROUTE_PATHS.EMPLOYEE_DETAIL]
      },
      {
        key: 'employee_import',
        title: 'sidebar.employeeImport',
        path: ROUTE_PATHS.EMPLOYEE_IMPORT,
        role: roles.EMPLOYEE_IMPORT,
      }
    ],
  },
  {
    key: 'program',
    title: 'sidebar.program',
    icon: <AreaChartOutlined />,
    path: ROUTE_PATHS.PROGRAM_MANAGEMENT,
    role: roles.PROJECT_INDEX,
    childrens: [
      ROUTE_PATHS.PROGRAM_DETAIL,
      ROUTE_PATHS.SALARY_PROGRAM_DETAIL,
      ROUTE_PATHS.PROJECT_TIMESHEET_DETAIL
    ]
  },
  {
    key: 'timeKeeping',
    title: 'sidebar.timeKeeping',
    icon: <ExperimentOutlined />,
    path: ROUTE_PATHS.TIMEKEEPING_MANAGEMENT,
    role: roles.PROJECT_INDEX,
    childrens: [
      ROUTE_PATHS.TIMEKEEPING_DETAIL_INFO_MANAGEMENT,
      ROUTE_PATHS.TIMESHEET_DETAIL,
      ROUTE_PATHS.TIMEKEEPING_DETAIL,
      ROUTE_PATHS.ATTENDANCE_RECORDS_IMPORT
    ]
  },
  {
    key: 'salaryCalculate',
    title: 'sidebar.salaryCalculate',
    icon: <CalculatorOutlined />,
    path: ROUTE_PATHS.SALARY_CALCULATE_MANAGEMENT,
    role: roles.SALARY_RECORD_INDEX,
    childrens: [
      ROUTE_PATHS.SALARY_CALCULATE_DETAIL,
      ROUTE_PATHS.SALARY_CALCULATE_PERIOD_DETAIL,
      ROUTE_PATHS.SALARY_CALCULATE_TABLE_DETAIL,
      ROUTE_PATHS.SALARY_CALCULATE_IMPORT
    ]
  },
  {
    key: 'approveSalary',
    title: 'sidebar.approveSalary',
    icon: <CarryOutOutlined />,
    items: [
      {
        key: 'ApproveSalary',
        title: 'sidebar.waitingApproveSalary',
        path: ROUTE_PATHS.APPROVE_SALARY_MANAGEMENT,
        role: roles.APPROVE_DEPARTMENT_INDEX,
        childrens: [
          ROUTE_PATHS.APPROVE_SALARY_DETAIL,
          ROUTE_PATHS.APPROVE_HISTORY,
          ROUTE_PATHS.APPROVE_HISTORY_DETAIL
        ]
      },
      {
        key: 'ApprovedSalary',
        title: 'sidebar.approvedSalary',
        path: ROUTE_PATHS.APPROVED_SALARY_MANAGEMENT,
        role: roles.PAYROLL_PERIOD_APPROVED,
        childrens: [
          ROUTE_PATHS.APPROVED_SALARY_DETAIL,
          ROUTE_PATHS.APPROVED_SALARY_DETAIL,
        ]
      }
    ]
  },
  {
    key: 'position',
    title: 'sidebar.position',
    icon: <ToolOutlined />,
    path: ROUTE_PATHS.POSITION_MANAGEMENT,
    role: roles.POSITION_INDEX,
    childrens: [
      ROUTE_PATHS.POSITION_DETAIL,
    ]
  },
  {
    key: 'employeeAssign',
    title: 'sidebar.employeeAssign',
    icon: <UsergroupAddOutlined />,
    path: ROUTE_PATHS.EMPLOYEE_ASSIGN_MANAGEMENT,
    role: roles.EMPLOYEE_ASSIGN_INDEX,
    childrens: [ROUTE_PATHS.EMPLOYEE_ASSIGN_DETAIL]
  },
  {
    key: 'employeeFullTime',
    title: 'sidebar.employeeFullTime',
    icon: <UserOutlined />,
    path: ROUTE_PATHS.EMPLOYEE_FULLTIME_MANAGEMENT,
    role: roles.EMPLOYEE_FULLTIME_INDEX,
    childrens: [ROUTE_PATHS.EMPLOYEE_FULLTIME_DETAIL]
  },
  {
    key: 'bank',
    title: 'sidebar.bank',
    icon: <MoneyCollectOutlined />,
    role: roles.BANK_INDEX,
    path: ROUTE_PATHS.BANK_MANAGEMENT,
    childrens: [ROUTE_PATHS.BANK_DETAIL]
  },
  {
    key: 'exportReports',
    title: 'sidebar.exportReports',
    icon: <ExportOutlined />,
    path: ROUTE_PATHS.EXPORT_SALARY_SUMMARY,
    role: roles.EXPORT_INDEX,
    childrens: [
      ROUTE_PATHS.PREVIEW_FILE,
    ]
  },
  {
    key: 'email_template',
    title: 'sidebar.emailTemplate',
    icon: <MailOutlined />,
    path: ROUTE_PATHS.EMAIL_TEMPLATE_MANAGEMENT,
    role: roles.EMAIL_TEMPLATE_INDEX,
    childrens: [ROUTE_PATHS.EMAIL_TEMPLATE_DETAIL]
  },
  {
    key: 'tools',
    title: 'sidebar.tools',
    icon: <ToolOutlined />,
    items: [
      {
        key: 'fe_translation',
        title: 'sidebar.feTranslations',
        path: ROUTE_PATHS.FE_TRANSLATION_MANAGEMENT,
        role: roles.FE_TRANSLATION_INDEX,
      },
      {
        key: 'cms_translation',
        title: 'sidebar.cmsTranslations',
        path: ROUTE_PATHS.CMS_TRANSLATION_MANAGEMENT,
        role: roles.CMS_TRANSLATION_INDEX,
      },
      {
        key: 'redirect',
        title: 'sidebar.redirect',
        path: ROUTE_PATHS.REDIRECT_MANAGEMENT,
        role: roles.REDIRECT_INDEX,
      },
    ],
  },
  {
    key: 'system',
    title: 'sidebar.system',
    icon: <SettingOutlined />,
    items: [
      {
        key: 'system_management',
        title: 'sidebar.general',
        path: ROUTE_PATHS.SYSTEM_MANAGEMENT,
        role: roles.SYSTEM_INDEX,
      },
      {
        key: 'user_management',
        title: 'sidebar.users',
        path: ROUTE_PATHS.USERS_MANAGEMENT,
        role: '*',
      },
      {
        key: 'roles',
        title: 'sidebar.roles',
        path: ROUTE_PATHS.ROLES_MANAGEMENT,
        role: '*',
      },
      {
        key: 'activity_logs',
        title: 'sidebar.activityLogs',
        path: ROUTE_PATHS.ACTIVITY_MANAGEMENT,
        role: roles.ACTIVITYLOG_INDEX,
      },
    ],
  },
];

export default menuSidebar;
